<template>
  <div class="view">
    <!-- <div id="AddPropertyForm" v-if="this.showAddPropertyForm == true" class="form-container">
      <el-card class="form-card">
      <el-form :model="form" ref="form" :rules="rules">
          <el-form-item label="Image">
            <PictureUpload
              v-on:picture-id="handlePictureid($event)"
              v-on:removePictureId="RemovePictureIdLocally($event)"
            />
          </el-form-item>

          <el-form-item label="Property Name" prop="propertyname">
            <el-input
              class="tst-property-name"
              v-model="form.propertyname"
              :rules="inputRules"
              placeholder="ex: Brooklyn Heights Apartment Complex"
              required
            ></el-input>
          </el-form-item>

          <el-form-item label="Search for address:">
            <br />
            <vue-google-autocomplete
              ref="googleAddress"
              id="map"
              class="google-map-field"
              placeholder="Please type your address"
              v-on:placechanged="setAddressData"
            ></vue-google-autocomplete>
          </el-form-item>

          <el-form-item label="Address">
            <el-input
              class="tst-property-address"
              v-model="form.address"
              :rules="inputRules"
              placeholder="ex: 21 Green Street"
              required
            ></el-input>
          </el-form-item>
          <el-form-item label="City">
            <el-input
              class="tst-property-city"
              v-model="form.city"
              :rules="inputRules"
              placeholder="ex: New York City"
              required
            ></el-input>
          </el-form-item>

          <el-form-item label="State">
            <el-input class="tst-property-state"
              v-model="form.state" :rules="inputRules" placeholder="ex: New York" required></el-input>
          </el-form-item>

          <el-form-item label="Zipcode">
            <el-input class="tst-property-zip"
              v-model="form.zip" :rules="inputRules" placeholder="ex: 11234" required></el-input>
          </el-form-item>

          <el-form-item label="Country">
            <el-input class="tst-property-country"
              v-model="form.country" :rules="inputRules" placeholder="ex: USA" required></el-input>
          </el-form-item>

          <div class="buttons">
            <el-button class="tst-confirm-create-property-button"
              type="primary" icon="el-icon-check" @click="SubmitForm()">Add Property</el-button>
            <br />
            <el-button class="tst-cancel-create-button"
              type="info" icon="el-icon-delete" @click="toggleAddPropertyForm()">Cancel</el-button>
          </div>
        </el-form>
      </el-card>
    </div>  -->



    <!-- the event listeners for "CreatePropertyForm" are in mounted(), due to the component not listening 
         to the event in the regular way (reason unknown) -->
     
      <CreatePropertyForm
      v-if="this.showAddPropertyForm == true"
       ></CreatePropertyForm>

    <EditPropertyForm
      v-if="this.showEditPropertyForm == true"
      :property="this.currenteditproperty"
      v-on:updated-property="updatePropertyLocally($event)"
      v-on:close-edit-property="toggleeditpropertyform()"
    />
    <DeletePropertyForm
      v-if="this.showDeletePropertyForm == true"
      :property="this.currentdeleteproperty"
      v-on:delete-property-locally="deletePropertyLocally($event)"
      v-on:close-delete-property-form="toggleDeletePropertyForm()"
    />
    <!-- <UserLeavePropertyForm
      v-if="this.showLeavePropertyForm == true"
      :property="this.currentleaveproperty"
      v-on:delete-property-locally="deletePropertyLocally($event)"
      v-on:close-leave-property-form="toggletechleavepropertyform()"
    /> -->
    <div
      v-show="
        showAddPropertyForm == false &&
          showEditPropertyForm == false &&
          showDeletePropertyForm == false &&
          showLeavePropertyForm == false
      "
    >
      <div @click="toggleAddPropertyForm()">
        <fab class="tst-add-property-fab"
              :position="position" bg-color="#02746E" icon="add"></fab>
      </div>
      <!--<el-button type="primary"  @click="toggleAddPropertyForm()">Add Property</el-button>-->

      <div v-if="this.loadingProperties" class="loader">Loading...</div>

      <div v-else>
        <div class="searchsortbar view">
          <el-input
            placeholder="Search or filter properties..."
            size="mini"
            v-model="search"
            class="searchbarelement"
          ></el-input>

          <el-dropdown class="searchbarinput" trigger="click" @command="SortBy">
            <el-button type="primary" size="mini">
              Sort by
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="alphabetical">Alphabetical</el-dropdown-item>
              <el-dropdown-item command="owner">By Owner</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div v-if="this.properties.length == 0" style="padding:15%; color:gray;">
          <h1>
            You dont have any properties yet, please click the add property
            button
            <i
              class="el-icon-plus"
            ></i> to add a property.
            <br />Or ask your manager to invite you to a property.
          </h1>
        </div>

        <div class="cards">
          <property-card
            v-for="property in searchProperties(sortedProperties)"
            :key="property.propertyid"
            :property="property"
            v-on:delete-property="toggleDeletePropertyForm($event)"
            v-on:updated-property="updatePropertyLocally($event)"
            v-on:open-edit-property-form="toggleeditpropertyform($event)"
          ></property-card>

          <div class="mycard" style="min-width:320px;" />
          <div class="mycard" style="min-width:320px;" />
          <div class="mycard" style="min-width:320px;" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import EventService from "@/services/EventService.js";
import PictureUpload from "@/components/utilities/PictureUploadSingle.vue";
import EditPropertyForm from "@/components/property/EditPropertyForm.vue";
import DeletePropertyForm from "@/components/property/DeletePropertyForm.vue";
//import UserLeavePropertyForm from "@/team/UserLeavePropertyForm.vue";
import PropertyCard from "@/components/property/PropertyCard.vue";
import fab from "vue-fab";
//import VueGoogleAutocomplete from "vue-google-autocomplete";
import CreatePropertyForm from "@/components/property/CreatePropertyForm.vue";

export default {
  components: {
    PropertyCard,
    fab,
    EditPropertyForm,
    DeletePropertyForm,
    //UserLeavePropertyForm,
    PictureUpload,
   // VueGoogleAutocomplete,
    CreatePropertyForm
  },
  created() {
    this.newTitle("Your Properties");
    this.loadingProperties = true;
    EventService.getAllProperties()
      .then(response => {
        console.log(response)
        this.properties = response.data.propertylist;
       this.loadingProperties = false;
  })
      
  },

  data() {
    return {
      sortmode: undefined,
      position: "bottom-right",
      fabActions: [
        {
          name: "test",
          icon: "cached"
        }
      ],
      search: "",
      properties: [],
      loadingProperties: false,
      modals: {
        add: false
      },
      showAddPropertyForm: false,
      showEditPropertyForm: false,
      showDeletePropertyForm: false,
      showLeavePropertyForm: false,
      currenteditproperty: {},
      currentdeleteproperty: {},
      currentleaveproperty: {},
      googleAddress: "",
      dialogVisible: false,
      form: {
        propertyname: null,
        address: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        organizationtypes: [],
        pictureid: []
      },
      inputRules: [v => (v && v.length != 0) || "This field is required"],
         rules: {
          propertyname: [
            { required: true, message: 'Please input Property name', trigger: 'blur' },
          ],
       },
       invalid: Boolean
    };
  },

  mounted() {


    this.$root.$on("close-form", () => this.closeFormsFromBackButton());
      this.$root.$on("property-added", ($event) => this.addPropertyLocally($event));
           this.$root.$on("close-add-property", () => this.toggleAddPropertyForm());
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    }),
    sortedProperties: function() {
      function alphabetizeProperties(a, b) {
        if (a.propertyname.toUpperCase() < b.propertyname.toUpperCase())
          return -1;
        if (a.propertyname.toUpperCase() > b.propertyname.toUpperCase())
          return 1;
        return 0;
      }
      function alphabetizeOwners(a, b) {
        if (a.ownerfirstname.toUpperCase() < b.ownerfirstname.toUpperCase())
          return -1;
        if (a.ownerfirstname.toUpperCase() > b.ownerfirstname.toUpperCase())
          return 1;
        return 0;
      }

      if (this.sortmode === "alphabetical") {
        return this.properties.slice().sort(alphabetizeProperties);
      }
      if (this.sortmode === "owner") {
        return this.properties.slice().sort(alphabetizeOwners);
      }
      return this.properties;
    }
  },
  methods: {
    ...mapActions(["getSpecificProperty", "newTitle"]),
    SortBy(option) {
      this.sortmode = option;
    },
    searchProperties() {
      return this.sortedProperties.filter(property =>
        property.propertyname.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    test401() {
      EventService.test401();
    },
    handleClose(done) {
      this.$confirm("Are you sure you want to close this dialog?")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },

    addPropertyLocally($event) {

           this.properties.push($event);

      //       this.$refs["form"].validate((valid) => {
      //     if (valid) {
      //     } else {
      //       this.invalid = true;
      //       return false;
      //     }
      //   });
      //   if(this.invalid == true){
      //     this.invalid = false;
      //     return;
      //   }

      // this.form.organizationtypes = Object.values(this.form.organizationtypes);

      // EventService.addProperty(this.form)
      //   .then(response => {
      //     this.properties.push(response.data);
      //   })
      //   .then(response => {
      //     this.$store.dispatch("addNotification", {
      //       type: "success",
      //       Message: "Property has been added"
      //     });
      //   });

      // this.toggleAddPropertyForm();
    },
    toggleAddPropertyForm() {
      this.showAddPropertyForm = !this.showAddPropertyForm;
      this.changeBackButton();
    },
    changeBackButton() {
      this.$root.$emit("form-toggled");
    },
    closeFormsFromBackButton() {
      (this.showAddPropertyForm = false),
        (this.showEditPropertyForm = false),
        (this.showDeletePropertyForm = false),
        (this.showLeavePropertyForm = false);
    },
    toggleeditpropertyform($event) {
      console.log("toggle edit property is working");
      this.currenteditproperty = $event;
      this.showEditPropertyForm = !this.showEditPropertyForm;
      this.changeBackButton();
    },
    toggleDeletePropertyForm(property) {
      this.currentdeleteproperty = property;
      this.showDeletePropertyForm = !this.showDeletePropertyForm;
      this.changeBackButton();
    },
    // toggletechleavepropertyform(property) {
    //   this.currentleaveproperty = property;
    //   this.showLeavePropertyForm = !this.showLeavePropertyForm;
    //   this.changeBackButton();
    // },
    handlePictureid($event) {
      //for (const object of $event) {
      this.form.pictureid.push($event.pictureid);
      //}
    },
    RemovePictureIdLocally(img) {
      this.$delete(this.form.pictureid, this.form.pictureid.indexOf(img));
    },
    deletePropertyLocally(property) {
      this.$delete(this.properties, this.properties.indexOf(property));
    },
    updatePropertyLocally($event) {
      this.$set(this.properties, this.properties.indexOf($event[1]), $event[0]);
      this.toggleeditpropertyform();
    },

    // setAddressData: function(addressData, placeResultData, id) {
    //   const addressComponents = placeResultData.address_components;
    //   const streetNumberComponent = addressComponents.find(({ types }) =>
    //     types.includes("street_number")
    //   );
    //   const streetNameComponent = addressComponents.find(({ types }) =>
    //     types.includes("route")
    //   );
    //   const addressComponent = streetNumberComponent
    //     ? streetNumberComponent.long_name + ""
    //     : "" + streetNameComponent
    //     ? streetNameComponent.long_name
    //     : "";
    //   const zipComponent = addressComponents.find(({ types }) =>
    //     types.includes("postal_code")
    //   );
    //   const cityComponent = addressComponents.find(
    //     ({ types }) =>
    //       types.includes("administrative_area_level_3") ||
    //       types.includes("sublocality_level_1")
    //   );
    //   const stateComponent = addressComponents.find(({ types }) =>
    //     types.includes("administrative_area_level_1")
    //   );
    //   const countryComponent = addressComponents.find(({ types }) =>
    //     types.includes("country")
    //   );

    //   this.form.address = addressComponent;
    //   this.form.zip = zipComponent ? zipComponent.long_name : "";
    //   this.form.city = cityComponent ? cityComponent.long_name : "";
    //   this.form.state = stateComponent ? stateComponent.long_name : "";
    //   this.form.country = countryComponent ? countryComponent.long_name : "";
    // }
  }
};
</script>
<style scoped>
h2{
  text-align: center;
}
h3{
  text-align: center;
}
.view {
  max-width: 100%;
  width: 100%;
  overflow: hidden;
}
.google-map-field {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.searchbarelement {
  max-width: 300px;
}
.searchbarinput {
  margin-right: 44px;
}
</style>



